import domain from "./domain";

// Resets all modal data
export const resetSubscriptionCreateModalData = domain.createEvent('resetSubscriptionCreateModalData');

// Reset coupon data
export const resetCoupon = domain.createEvent('resetCoupon');
